/**
 * Returns true if the subscription (or subscription-like object with isMixProduct, bundleType, playServices)
 * should have mix/play products added to the cart (MIX bundle or MEDIA with play services).
 */
function isMediaWithPlayServices (sub) {
  const count = sub?.playServices?.length ?? 0
  return sub?.bundleType === 'MEDIA' && count > 0
}
export function subscriptionHasPlayServicesToAdd (sub) {
  return !!sub?.isMixProduct
}

export function subscriptionHasPlayServices (sub) {
  return !!(sub?.isMixProduct || isMediaWithPlayServices(sub))
}
